import React from "react";
import "../App"; // Import the CSS file

const ScreenTimeChallenge = () => {
  return (
    <div className="container">
      <h1>✨ Welcome to Fashioniste</h1>
      <p>
        Your personal OOTD (Outfit of the Day) and fashion journal. Share your daily style, 
        discover inspiration from a community of fashion enthusiasts, and build your fashion journey.
      </p>

      <div className="feature-list">
        <div className="feature-item">
          <span>📸</span>
          <p>Capture your outfits and express your unique style</p>
        </div>
        <div className="feature-item">
          <span>👗</span>
          <p>Discover new fashion trends and get inspired</p>
        </div>
        <div className="feature-item">
          <span>💫</span>
          <p>Connect with others who share your passion for fashion</p>
        </div>
      </div>

      <button className="cta-button">Start Your Fashion Journey 🎨</button>

      <p className="tagline">Document your daily looks. Discover style inspiration. <br /> Fashioniste - Your fashion companion</p>
    </div>
  );
};

export default ScreenTimeChallenge;

